const SET =   "app/modal/SET";
const UNSET = "app/modal/UNSET";

export default {
  SET,
  UNSET,
}



// WEBPACK FOOTER //
// ./src/redux/modal/types.js